module.exports = __webpack_public_path__ + "static/media/GuardiansOfAether-Gallery-02.c5fbe5f5.jpg";